import React, { useEffect, useState } from 'react'

import { sankeyService } from './sankey.service'
import { useTooltipDisplayContext } from '../../common/tooltip/tooltip.context'

import { useStyles } from './selected-segments.style'

export const SelectedSegments = function ({ sankeyData, selectedDemographicCategory, selectedSegmentSize }) {
  const classes = useStyles()

  const [svgElements, setSvgElements] = useState([])
  const [focusedSegment, setFocusedSegment] = useState({})
  const [, setTooltipDisplayData] = useTooltipDisplayContext()

  useEffect(() => {
    const isDemographicCategorySelected = (selectedDemographicCategory !== -1)
    const segments = []

    sankeyData.iterateThroughSelectedSegments(function (segment, stage, state, demographicValue) {
      segments.push(
        <rect key={`ss-${stage}-${state}-${demographicValue}`}
          className={classes.nodeRectSelect}
          x={segment.left} y={segment.top}
          width={segment.width} height={segment.height}
          fill={isDemographicCategorySelected ? sankeyData.layout.getDemographicColor(selectedDemographicCategory, demographicValue) : sankeyData.layout.getStateColor(state)}
          onMouseOver={() => { handleMouseOver(segment, stage, state, demographicValue) }}
          onMouseOut={handleMouseOut} />
      )
    })

    setSvgElements(segments)
  }, [sankeyData, focusedSegment])

  function handleMouseOver (segment, stage, state, demographicValue) {
    setFocusedSegment({ stage, state, demographicValue })

    setTooltipDisplayData(
      sankeyService.getStateTooltipDisplayObject({
        stateName: sankeyData.layout.stateLabels[state],
        value: segment.size,
        denominator: selectedSegmentSize
      })
    )
  }

  function handleMouseOut () {
    setTooltipDisplayData()
    setFocusedSegment({})
  }

  return svgElements
}
